import { render } from "./uploadZBList.vue?vue&type=template&id=1aa8503f&scoped=true"
import script from "./uploadZBList.vue?vue&type=script&lang=js"
export * from "./uploadZBList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa8503f"]])

export default __exports__